import React, { useState, useEffect, useRef } from "react";
import {
  Card,
  CardBody,
  Col,
  Row,
  Modal,
  ModalBody,
  Tooltip,
} from "reactstrap";
import qa from "../../assets/images/qa.png";
import qb from "../../assets/images/qb.png";
import qc from "../../assets/images/qc.png";
import { Box, Tabs, Tab, Typography } from "@mui/material";
import msc from "../../assets/images/msc-certified.png";
import dfar from "../../assets/images/dfar-certified.png";
import JobImage10 from "../../assets/images/user/img-01.jpg";
import QR from "../../assets/images/qr.png";
import { Link } from "react-router-dom";
import JobSearchOptions from "./../Orders/JobSearchOptions";
import DataTable from "react-data-table-component";
import MapView from "./mapView";
import Swal from "sweetalert2";
import {
  getBookmark,
  addItemToBookmark,
} from "../../api/BookMarks/BookmarkApi.js";
import { getVessel } from "../../api/VesselDetails/addVesselApi";
import { checkCof } from "../../api/cof.js";
import VesselDetailsOffcanvas from "./VesselDetailsOffcanvas";
import BoatOwnerDetailsView from "../BoatOwner/BoatOwnerDetailsView";
import BoatOwners from "./../BoatOwner/BoatOwnerList";
import ReviewList from "./ReviewList.js";
import ReviewForm from "./ReviewForm.js";
import CircularProgress from "./CircularProgress.js";

const StockDetailsDescription = ({
  stockData,
  CofData,
  ItemData,
  processingCost,
  showOffCanvas,
}) => {
  // Generate a unique ID for this component instance
  const componentId = useRef(
    `stock-details-${Math.random().toString(36).substr(2, 9)}`
  );

  console.log(`[${componentId.current}] StockDetailsDescription rendered`);
  console.log(`[${componentId.current}] Stock Data:`, stockData);
  console.log(`[${componentId.current}] Item Data:`, ItemData);

  // Normalize ItemData to ensure it's an array
  const normalizedItemData = Array.isArray(ItemData) ? ItemData : [];

  // Track DataTable renders
  const dataTableRenderCount = useRef(0);

  const [value, setValue] = useState(0);
  const [selectedCatchLocations, setSelectedCatchLocations] = useState([]);
  const [modal, setModal] = useState(false);
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [isBookmarked, setIsBookmarked] = useState(false);
  const [isOffcanvasOpen, setIsOffcanvasOpen] = useState(false);
  const [selectedVessel, setSelectedVessel] = useState(null);
  const [show, setShow] = useState(false);
  const [selectedOwner, setSelectedOwner] = useState(null);

  const checklistLabels = [
    "Mechanical readiness of the Vessel",
    "Equipment availability within the vessel to ensure 'Safety at Sea'",
    "Ensure dedicated safety equipment is always accessible, operational, and correctly maintained/serviced by vessel owners",
    "Appropriate medical equipment and medicine exists on board for number of crew and length of trip",
    "Equipment readiness within the vessel to carry out fishing activities",
    "Crew living conditions and accommodation",
    "Ability to provide protection in the event of a collision or fire",
    "Crew has a place to relax and rest which is ventilated, insulated, and separated from work areas",
    "Sanitation and washing areas are maintained in a clean and operational condition",
    "Availability of insurance certificate for the vessel",
    "Medical certification requirements to ensure every crew member is fit to perform their duties",
    "Essential crew safety training that had been done. The boat needs to have accurate and up-to-date crew and training records",
    "Accident and incident recording requirements and an accident prevention plan",
    "Contracts of the Crew members with the boat owner",
  ];

  const handleBadgeClick = async (tripId) => {
    try {
      if (!tripId) {
        throw new Error("Vessel number is not provided");
      }

      // Show loading state
      Swal.fire({
        title: "Loading...",
        text: "Fetching DFAR certification data...",
        icon: "info",
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      // Fetch data
      const cofData = await checkCof(tripId);
      console.log(`Cof Data:`, cofData.data[0]);
      const { checklist, images } = cofData.data[0];
      Swal.close();

      // Ensure checklist and images arrays have the same length
      const items = checklist.map((item, index) => ({
        check: item,
        image: images[index] || null, // Fallback if image is missing
      }));

      // Format checklist and images for display
      const checklistHtml = items
        .map(
          (item, index) => `
           <li style="border-bottom:1px solid #D8D8D8; display: flex; justify-content: space-between; padding-bottom:5px; align-items: center; margin-bottom: 15px; gap: 10px; font-size: 0.8em;">
  <span style="flex-grow: 1;">${checklistLabels[index]}</span>

  <span style="
    background: ${item.check ? "#28a745" : "#dc3545"};
    font-weight: bold;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    border-radius: 50%;
    flex-shrink: 0;
  ">
    ${item.check ? "✓" : "✗"}
  </span>

  ${
    item.image
      ? `<a href="#" class="image-preview" data-image="${
          item.image
        }" data-index="${index}">
          <img src="${item.image}" alt="Certificate Image ${
          index + 1
        }" style="width: 50px; height: 50px; object-fit: cover; border-radius: 8px;" />
         </a>`
      : '<span style="font-size: 0.9em; color: #888;"></span>'
  }
     
</li>
`
        )
        .join("");

      // Show main popup with checklist and images
      Swal.fire({
        title: "DFAR Certification",
        html: `
        <div className="badge bg-primary text-white d-inline-flex align-items-center px-2 py-1" style="background: #e1e1e1; font-size: 0.8rem; border-radius: 50px; display: inline-block; color: #209f20; padding: 10px;" >
          <img src="/verified.png" style="width: 20px;"/>
        This Vessel is DFAR Certified
      </div>
          <div style="text-align: left;">
            
            <h5>Checklist:</h5>
            <ul style="list-style-type: none; padding-left: 0;">${checklistHtml}</ul>
          </div>`,
        icon: "info",
        confirmButtonText: "OK",
        confirmButtonColor: "#3085d6",
        width: "800px", // Increased width for better visibility
        allowOutsideClick: false, // Prevent closing main popup accidentally
        didOpen: () => {
          // Add click handlers for image previews
          document.querySelectorAll(".image-preview").forEach((element) => {
            element.addEventListener("click", (e) => {
              e.preventDefault();
              const imageUrl = element.getAttribute("data-image");
              const index = parseInt(element.getAttribute("data-index"));
              // Open image in new tab instead of Swal popup
              window.open(imageUrl, "_blank");
            });

            // Add hover zoom effect
            const img = element.querySelector("img");
            if (img) {
              element.addEventListener("mouseenter", () => {
                img.style.transform = "scale(1.2)";
              });
              element.addEventListener("mouseleave", () => {
                img.style.transform = "scale(1)";
              });
            }
          });
        },
      });
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: `Failed to fetch DFAR certification data: ${error.message}`,
        icon: "error",
        confirmButtonText: "OK",
        confirmButtonColor: "#d33",
      });
    }
  };
  const handleOwnerClick = (owner) => {
    setSelectedOwner(owner);
    setShow(true);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const toggleModal = () => {
    setShow(!show);
    if (show) setSelectedOwner(null);
  };

  function TabPanel({ children, value, index, ...other }) {
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`tabpanel-${index}`}
        aria-labelledby={`tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 2 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  const openModal = () => setModal(!modal);
  const toggleTooltip = () => setTooltipOpen(!tooltipOpen);

  const fetchBookmarkData = async (userId, itemId) => {
    try {
      const response = await getBookmark(userId, itemId);
      const data = response.data;
      if (data.status === "active") {
        setIsBookmarked(true);
      } else {
        setIsBookmarked(false);
      }
    } catch (error) {
      setIsBookmarked(false);
      console.error(
        `[${componentId.current}] Error fetching bookmark data:`,
        error
      );
    }
  };

  const handleVesselClick = async (boatNumber) => {
    try {
      const response = await getVessel(boatNumber);
      const vesselData = response.data;
      setSelectedVessel(vesselData);
      setIsOffcanvasOpen(true);
    } catch (error) {
      console.error(
        `[${componentId.current}] Error fetching vessel data:`,
        error
      );
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to fetch vessel details.",
        showConfirmButton: false,
        timer: 1500,
        position: "top-end",
        toast: true,
        background: "#333",
        color: "#fff",
        timerProgressBar: true,
      });
    }
  };

  useEffect(() => {
    if (stockData?.Boat_Number) {
      fetchBookmarkData("12345", stockData._id);
    }
  }, [stockData]);

  const handleBookmark = async (stock_id) => {
    const addData = {
      userId: "12345",
      itemId: stock_id,
      status: "active",
    };

    try {
      const response = await addItemToBookmark(addData);
      const data = response.data;
      if (data.status === "active") {
        setIsBookmarked(true);
        Swal.fire({
          icon: "success",
          title: "Bookmark added",
          text: "The item has been added to your bookmarks.",
          showConfirmButton: false,
          timer: 1500,
          position: "top-end",
          toast: true,
          background: "#333",
          color: "#fff",
          timerProgressBar: true,
        });
      } else {
        setIsBookmarked(false);
        Swal.fire({
          icon: "warning",
          title: "Bookmark removed",
          text: "The item has been removed from your bookmarks.",
          showConfirmButton: false,
          timer: 1500,
          position: "top-end",
          toast: true,
          background: "#333",
          color: "#fff",
          timerProgressBar: true,
        });
      }
    } catch (error) {
      console.error(`[${componentId.current}] Error handling bookmark:`, error);
    }
  };

  const columns = [
    {
      name: "QR Code",
      selector: (row) => row.qrCode,
      sortable: true,
    },
    {
      name: "Catch Location",
      selector: (row) => row.catchLocation,
    },
    {
      name: "Catch Date",
      selector: (row) => new Date(row.catchDatetime).toLocaleDateString(),
      sortable: true,
    },
    {
      name: "Weight",
      selector: (row) => row.weight,
    },
    {
      name: "Quality",
      selector: (row) => row.quality,
    },
  ];

  const [selectedItems, setSelectedItems] = useState([]);

  const handleSelectedRowsChange = (state) => {
    setSelectedItems(state.selectedRows);
  };

  const formatProductName = (name) => {
    return name.replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const ProgressBox = ({ name, percentage }) => {
    const roundedPercentage = Math.round(
      Math.max(0, Math.min(100, percentage))
    );

    return (
      <div
        style={{ marginRight: "20px", display: "inline" }}
        className="flex flex-col gap-4 items-center justify-center bg-white rounded-lg shadow-lg percentage-section p-4 w-40 h-40 relative"
      >
        <div className="relative w-24 h-24 d-flex items-center justify-center">
          <svg className="w-full h-full" viewBox="0 0 100 100">
            <circle
              className="text-gray-200"
              strokeWidth="10"
              stroke="currentColor"
              fill="transparent"
              r="40"
              cx="50"
              cy="50"
            />
            <circle
              className="text-green-500"
              strokeWidth="10"
              stroke="currentColor"
              fill="transparent"
              r="40"
              cx="50"
              cy="50"
              strokeDasharray={`${roundedPercentage * 2.51} ${
                251.2 - roundedPercentage * 2.51
              }`}
              strokeDashoffset="0"
              transform="rotate(-90 50 50)"
            />
            <text
              x="50"
              y="50"
              textAnchor="middle"
              dy=".3em"
              className="text-lg font-bold text-gray-800"
            >
              {roundedPercentage}%
            </text>
          </svg>
        </div>
        <h6 className="mt-2 text-sm font-medium text-center">{name}</h6>
      </div>
    );
  };

  const ProgressBox2 = () => {
    const roundedPercentage = Math.round(Math.max(0, Math.min(100, 20)));

    return (
      <div className="flex flex-col items-center justify-center">
        <h5 className="text-xl font-semibold p-2 shadow-lg percentage-section bg-white text-center w-full">
          Safety
        </h5>
        <div className="d-flex gap-6">
          <div
            style={{ minWidth: "150px" }}
            className="flex flex-col gap-2 items-center justify-center bg-white rounded-lg shadow-lg percentage-section-left p-4 w-30 h-30"
          >
            <div className="relative w-24 h-24 flex items-center justify-center">
              <svg className="w-full h-full" viewBox="0 0 100 100">
                <circle
                  className="text-gray-300"
                  strokeWidth="10"
                  stroke="currentColor"
                  fill="transparent"
                  r="40"
                  cx="50"
                  cy="50"
                />
                <circle
                  strokeWidth="10"
                  stroke="#ef4444"
                  fill="transparent"
                  r="40"
                  cx="50"
                  cy="50"
                  strokeDasharray={`${20 * 2.51} ${251.2 - 20 * 2.51}`}
                  strokeDashoffset="0"
                  transform="rotate(-90 50 50)"
                />
                <text
                  x="50"
                  y="50"
                  textAnchor="middle"
                  dy=".3em"
                  className="text-lg font-bold text-black"
                >
                  20%
                </text>
              </svg>
            </div>
            <h6 className="text-sm font-medium text-center">Personnel</h6>
          </div>
          <div
            style={{ minWidth: "150px" }}
            className="flex flex-col gap-2 items-center justify-center bg-white rounded-lg shadow-lg percentage-section-right p-4 w-40 h-40"
          >
            <div className="relative w-24 h-24 flex items-center justify-center">
              <svg className="w-full h-full" viewBox="0 0 100 100">
                <circle
                  className="text-gray-300"
                  strokeWidth="10"
                  stroke="currentColor"
                  fill="transparent"
                  r="40"
                  cx="50"
                  cy="50"
                />
                <circle
                  strokeWidth="10"
                  stroke="#ef4444"
                  fill="transparent"
                  r="40"
                  cx="50"
                  cy="50"
                  strokeDasharray={`${20 * 2.51} ${251.2 - 20 * 2.51}`}
                  strokeDashoffset="0"
                  transform="rotate(-90 50 50)"
                />
                <text
                  x="50"
                  y="50"
                  textAnchor="middle"
                  dy=".3em"
                  className="text-lg font-bold text-black"
                >
                  20%
                </text>
              </svg>
            </div>
            <h6 className="text-sm font-medium text-center">Craft</h6>
          </div>
        </div>
      </div>
    );
  };

  const metrics = [
    { name: "Sustainability", percentage: 75 },
    { name: "Environment", percentage: 75 },
    { name: "ILO C188", percentage: 75 },
  ];

  return (
    <React.Fragment>
      <div className="job-detail overflow-hidden">
        <div>
          <Row>
            <Col md={8}>
              <span
                className="mb-4"
                style={{
                  fontSize: "30px",
                  fontWeight: "500",
                  marginBottom: "250px",
                }}
              >
                {stockData?.Product_Name || "N/A"} 
                <img
                  style={{ width: "30px", display: "inline-block" }}
                  src={
                    stockData?.Quality_Grade === "A"
                      ? qa
                      : stockData?.Quality_Grade === "B"
                      ? qb
                      : qc
                  }
                  alt="Quality Grade"
                />
              </span>
              <h2 style={{ fontWeight: "800" }} className="mt-3 mb-2 fw-900">
                LKR {stockData?.Price_per_Kg || "N/A"}/kg
              </h2>
              <h6 className="mb-1 stock-details-line3 align-items-center">
                <i className="uil uil-anchor me-2 text-gray"></i>
                <span className="text-gray">{stockData?.Harbour || "N/A"}</span>
                <span className="mx-2"></span>
                <i className="uil uil-ship me-2 text-gray"></i>
                <span
                  className="text-gray"
                  onClick={() => handleVesselClick(stockData?.Boat_Number)}
                  style={{ cursor: "pointer" }}
                >
                  {stockData?.Boat_Number || "N/A"}
                </span>
                <span className="mx-2"></span>
                <i className="mdi mdi-star align-middle text-gray"></i>
                <span className="badge text-gray">4.8</span>{" "}
                <div
                  className="badge bg-primary text-white d-inline-flex align-items-center px-2 py-1"
                  onClick={() => handleBadgeClick(stockData?.Trip_Number)} // Wrap in arrow function
                  style={{ cursor: "pointer" }}
                >
                  <i className="uil uil-shield-check me-2"></i>
                  DFAR Certified
                </div>
                <ul className="bookmark-mobile list-inline mb-0 text-lg-end mt-3 mt-lg-5">
                  <li className="list-inline-item">
                    <div className="favorite-icon">
                      <Link onClick={() => handleBookmark(stockData?._id)}>
                        <i
                          className={`uil ${
                            isBookmarked ? "uil-heart" : "uil-heart-alt"
                          }`}
                          style={{
                            color: isBookmarked ? "red" : "gray",
                            fontSize: "24px",
                            cursor: "pointer",
                            transition: "color 0.3s ease",
                          }}
                        ></i>
                      </Link>
                    </div>
                  </li>
                </ul>
              </h6>
            </Col>
            <Col lg={4}>
              <ul className="bookmark-web list-inline mb-0 text-lg-end mt-3 mt-lg-5">
                <li className="list-inline-item">
                  <div className="favorite-icon">
                    <Link onClick={() => handleBookmark(stockData?._id)}>
                      <i
                        className={`uil ${
                          isBookmarked ? "uil-heart" : "uil-heart-alt"
                        }`}
                        style={{
                          color: isBookmarked ? "red" : "gray",
                          fontSize: "24px",
                          cursor: "pointer",
                          transition: "color 0.3s ease",
                        }}
                      ></i>
                    </Link>
                  </div>
                </li>
              </ul>
            </Col>
          </Row>
        </div>
        <hr style={{ borderColor: "#444", borderWidth: "1px" }} />

        <CircularProgress stockData={stockData} />

        {/* <div className="pr-area1 d-flex justify-center gap-6">
          {metrics.map((metric, index) => (
            <ProgressBox
              key={index}
              name={metric.name}
              percentage={metric.percentage}
            />
          ))}
          <ProgressBox2 />
        </div> */}

        <hr style={{ borderColor: "#444", borderWidth: "1px" }} />

        <div className="mt-4">
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
            indicatorColor="none"
            textColor="primary"
            variant="fullWidth"
            sx={{ "& .MuiTabs-indicator": { display: "none" } }}
          >
            <Tab
              label="catch details"
              id="tab-0"
              aria-controls="tabpanel-0"
              sx={{ textTransform: "capitalize" }}
            />
            {/* <Tab
              label="seller details"
              id="tab-1"
              aria-controls="tabpanel-1"
              sx={{ textTransform: 'capitalize' }}
            />
            <Tab
              label="processing"
              id="tab-2"
              aria-controls="tabpanel-2"
              sx={{ textTransform: 'capitalize' }}
            /> */}
            <Tab
              label="reviews"
              id="tab-1"
              aria-controls="tabpanel-1"
              sx={{ textTransform: "capitalize" }}
            />
          </Tabs>
          <TabPanel value={value} index={0}>
            {console.log(
              `[${componentId.current}] Catch Details Tab rendered, ItemData:`,
              normalizedItemData
            )}
            <div
              className="job-overview"
              style={{
                listStyleType: "none",
                margin: "0px",
                padding: "0px",
              }}
            >
              <div className="me-4">
                <div className="d-flex mt-4">
                  <i className="uil uil-star-half-alt icon bg-primary-subtle text-primary"></i>
                  <div className="ms-3">
                    <h6 className="fs-14 mb-2">Scientific Name</h6>
                    <p className="text-muted mb-0">
                      {stockData?.Scientific_Name || "N/A"}
                    </p>
                  </div>
                </div>
              </div>
              <div className="me-4">
                <div className="d-flex mt-4">
                  <i className="uil uil-kayak icon bg-primary-subtle text-primary"></i>
                  <div className="ms-3">
                    <h6 className="fs-14 mb-2">Fishing Method</h6>
                    <p className="text-muted mb-0">
                      {stockData?.Fishing_Method || "N/A"}
                    </p>
                  </div>
                </div>
              </div>
              <div className="me-4">
                <div className="d-flex mt-4">
                  <i className="uil uil-calender icon bg-primary-subtle text-primary"></i>
                  <div className="ms-3">
                    <h6 className="fs-14 mb-2">Last Date of Catch</h6>
                    <p className="text-muted mb-0">
                      {stockData?.Last_Date_Of_Catch || "N/A"}
                    </p>
                  </div>
                </div>
              </div>
              <div className="me-4">
                <div className="d-flex mt-4">
                  <i className="uil uil-location-point icon bg-primary-subtle text-primary"></i>
                  <div className="ms-3">
                    <h6 className="fs-14 mb-2">Last Catch Location</h6>
                    <p className="text-muted mb-0">
                      {stockData?.Last_Catch_Location || "N/A"}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <p className="text-muted text-center mb-2 mt-2">Item Details</p>

            {normalizedItemData.length > 0 ? (
              <MapView data={normalizedItemData} />
            ) : (
              <p className="text-muted text-center">No map data available</p>
            )}
          </TabPanel>

          {/* <TabPanel
            value={value}
            index={2}
          >
            <div
              className="job-overview"
              style={{
                listStyleType: 'none',
                margin: '0px',
                padding: '0px',
              }}
            >
              <div className="me-4">
                <div className="d-flex mt-4">
                  <i className="uil uil-trash-alt icon bg-primary-subtle text-primary"></i>
                  <div className="ms-3">
                    <h6 className="fs-14 mb-2">Wastage</h6>
                    <p className="text-muted mb-0">N/A</p>
                  </div>
                </div>
              </div>
              <div className="me-4">
                <div className="d-flex mt-4">
                  <i className="uil uil-star icon bg-primary-subtle text-primary"></i>
                  <div className="ms-3">
                    <h6 className="fs-14 mb-2">Quality</h6>
                    <p className="text-muted mb-0">
                      {stockData?.Quality_Grade || 'N/A'}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </TabPanel> */}
          <TabPanel value={value} index={1}>
            <div
              className="job-overview"
              style={{
                listStyleType: "none",
                margin: "0px",
                padding: "0px",
              }}
            >
              <div className="vessel-section">
                <h6>Review</h6>
                <ReviewList reviewType={"Stock"} productId={stockData._id} />
              </div>
              <div className="vessel-section">
                <h6>Add a Review</h6>
                <ReviewForm
                  userId={"rtrt5456"}
                  reviewType={"Stock"}
                  productId={stockData._id}
                />
              </div>
            </div>
          </TabPanel>
        </div>

        <Modal isOpen={modal} toggle={openModal} role="dialog" centered>
          <ModalBody className="p-5">
            <div className="position-absolute end-0 top-0 p-3">
              <button
                type="button"
                className="btn-close"
                onClick={openModal}
              ></button>
            </div>
            <img src={QR} width="100%" alt="QR Code" />
          </ModalBody>
        </Modal>

        <VesselDetailsOffcanvas
          isOpen={isOffcanvasOpen}
          toggle={() => setIsOffcanvasOpen(false)}
          selectedVessel={selectedVessel}
        />
      </div>
      <BoatOwnerDetailsView
        isOpen={show}
        details={selectedOwner}
        toggle={toggleModal}
      />
    </React.Fragment>
  );
};

export default React.memo(StockDetailsDescription);
